<template>
  <div class="mnd-step mnd-codepart active">
    <div class="mnd-step__content">
      <div class="mnd-codepart__content">
        <template v-if="!confirmed">
          <p class="mnd-form__title mnd-codepart__title">
            На Ваш номер отправлен код
          </p>
          <p class="mnd-codepart__subtitle">Код отправлен на номер {{ form.contacts.tel }}</p>
          <NumberInput :mask="codemask" :maxlength="codelength" class="mnd-codepart__input" :required="true" @setError="errors.code = $event" v-model="code" text="Введите код из SMS" name="code" />
          <template v-if="tries">
            <template v-if="tries < maxtries">
              <p class="mnd-codepart__text" v-if="seconds">Повторная отправка доступна через {{ timertext }}</p>
              <p class="mnd-codepart__text" v-else><a @click.prevent="sendCode">Отправить код повторно</a></p>
            </template>
          </template>
          <Btn @click="checkCode" class="mnd-codepart__next" :disabled="!filled || loading">
            <svg v-if="(loading && tries)" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="40" height="40" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
              <circle cx="50" cy="50" r="32" stroke-width="8" stroke="#fff" stroke-dasharray="50.26548245743669 50.26548245743669" fill="none" stroke-linecap="round">
                <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="1s" keyTimes="0;1" values="0 50 50;360 50 50"></animateTransform>
              </circle>
            </svg>
            <span v-else>Далее</span>
          </Btn>
        </template>

        <template v-else>
          <p class="mnd-codepart__subtitle">Для оплаты нажмите кнопку далее. <br>Вас перенаправит на сайт оплаты.</p>
          <Btn @click="pay" class="mnd-codepart__next" :disabled="loading">
            <svg v-if="loading" xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
              <path d="M36.6663 19.9987C36.6663 29.2034 29.2044 36.6654 19.9997 36.6654C10.7949 36.6654 3.33301 29.2034 3.33301 19.9987C3.33301 10.794 10.7949 3.33203 19.9997 3.33203C29.2044 3.33203 36.6663 10.794 36.6663 19.9987ZM9.16634 19.9987C9.16634 25.9818 14.0166 30.832 19.9997 30.832C25.9828 30.832 30.833 25.9818 30.833 19.9987C30.833 14.0156 25.9828 9.16537 19.9997 9.16537C14.0166 9.16537 9.16634 14.0156 9.16634 19.9987Z" fill="url(#paint0_angular_11454_2280)" />
              <defs>
                <radialGradient id="paint0_angular_11454_2280" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(19.9997 19.9987) scale(16.6667)">
                  <stop offset="0.9999" stop-color="white" />
                  <stop offset="1" stop-color="#F22557" />
                </radialGradient>
              </defs>
            </svg>
            <span v-else>Далее</span>
          </Btn>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Btn from './ui/Btn.vue';
import NumberInput from './inputs/NumberInput.vue';
export default {
  data: () => ({
    errors: {},
    timer: null,
    code: '',
    codelength: 4,
    seconds: 0,
    tries: 0,
    maxtries: 3,
    loading: false,
    confirmed: false
  }),
  computed: {
    ...mapState(['urlToCheckSmsCode', 'urlToSendSmsCode', 'urlToPay', 'form', 'sendResponse']),
    codemask() {
      return ''.padStart(this.codelength, '#')
    },
    timertext() {
      if (!this.seconds) return '00:00'
      let mins = Math.floor(this.seconds / 60) + ''
      let secs = (this.seconds % 60) + ''
      return mins.padStart(2, '0') + ':' + secs.padStart(2, '0')
    },
    filled() {
      for (let key in this.errors)
        if (this.errors[key])
          return false;
      if (this.code.length < this.codelength)
        return false;
      return true;
    }
  },
  methods: {
    async pay() {
      this.loading = true
      await this.$store.dispatch('serverRequest', {
        url: this.urlToPay,
        guid: true,
        body: { form: this.form },
        onSuccess: (json) => {
          if (!json.link)
            throw ('Ссылка для оплаты не получена')
          window.location.href = json.link
        }
      })
      this.loading = false
    },
    async sendCode(first) {
      if (this.timer)
        return console.error('Ещё не прошло достаточно времени с предыдущей отправки')

      if (first !== true)
        this.loading = true

      let ok = await this.$store.dispatch('serverRequest', {
        url: this.urlToSendSmsCode,
        guid: true,
      })

      if (first !== true)
        this.loading = false

      if (!ok)
        return

      this.tries++

      this.seconds = 60
      clearInterval(this.timer)
      this.timer = setInterval(() => {
        this.seconds--
        if (this.seconds <= 0) {
          clearInterval(this.timer)
          this.timer = null
        }
      }, 1000)
    },
    async checkCode() {
      this.loading = true
      let ok = await this.$store.dispatch('serverRequest', {
        url: this.urlToCheckSmsCode,
        guid: true,
        body: {
          code: this.code
        }
      })
      console.log(ok)
      this.loading = false
      if (ok)
        this.confirmed = true
    }
  },
  components: { Btn, NumberInput }
}
</script>

<style lang="sass" scoped>
.mnd-codepart
  & &__title
    padding-bottom: 16px
  &__content
    display: flex
    flex-direction: column
    align-items: center
    max-width: globalvars.$slimwidth
    width: 100%
    margin: 0 auto
  &__subtitle
    text-align: center
    color: colors.$gray3
    font-size: 22px
    line-height: 1.16
    margin-bottom: 56px
  &__text
    color: colors.$gray3
    font-size: 18px
    line-height: 1.36
    text-align: center
    margin-bottom: 64px
    a
      cursor: pointer
      text-decoration: underline
  &__next
    svg
      margin: -8px auto
  &__input
    margin-bottom: 40px

</style>